import { Component } from '@angular/core';

@Component({
  selector: 'cva-standalone-error-500',
  templateUrl: './error-500.component.html',
})
export class Error500Component {

}
